export const useReferralBindingStore = defineStore('referralBinding', {
	state: () => ({
		mid: '',
		inviteCode: '',
	}),
	actions: {
		async bindReferral() {
			return;
			const { mid, inviteCode } = this.$state;
			if ((mid || inviteCode) && systemInfo().token) {
				let code = '';

				// #ifdef MP
				const LoginRes = await uni.login({ provider: 'weixin', onlyAuthorize: true });
				code = LoginRes.code || '';
				// #endif

				await request.post({
					resErr: true,
					showLoad: false,
					port: port.MEMBER_BINDMEMBER,
					params: this.setParams({ code }),
				});
			}
		},
		async setCode({ mid, inviteCode }: any = {}) {
			mid && (this.mid = mid);
			inviteCode && (this.inviteCode = inviteCode);
			await this.bindReferral();
		},
		setParams(params: any = {}) {
			params = cloneDeep(unref(params));
			merge(params, this.$state);
			return params;
		},
	},
});
